import { render } from "./TheProfessionalVideosGrid.vue?vue&type=template&id=2363ce8f&ts=true"
import script from "./TheProfessionalVideosGrid.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalVideosGrid.vue?vue&type=script&lang=ts"

import "./TheProfessionalVideosGrid.vue?vue&type=style&index=0&id=2363ce8f&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__